export { default as Add } from "./Add";
export { default as BazzarLogo } from "./BazzarLogo";
export { default as BitcoinConvert } from "./BitcoinConvert";
export { default as CallCallingBulk } from "./CallCallingBulk";
export { default as CallCalling } from "./CallCalling";
export { default as ClipboardText } from "./ClipboardText";
export { default as DollarCircleAbout } from "./DollarCircleAbout";
export { default as DollarCircle } from "./DollarCircle";
export { default as Gift } from "./Gift";
export { default as GooglePlayLogo } from "./GooglePlayLogo";
export { default as Headphone } from "./Headphone";
export { default as Instagram } from "./Instagram";
export { default as Linkedin } from "./Linkedin";
export { default as Minus } from "./Minus";
export { default as ProfileTick } from "./ProfileTick";
export { default as ShieldSecurityAbout } from "./ShieldSecurityAbout";
export { default as ShieldSecurity } from "./ShieldSecurity";
export { default as Sms } from "./Sms";
export { default as Teacher } from "./Teacher";
export { default as Twitter } from "./Twitter";
export { default as Verify } from "./Verify";
export { default as Youtube } from "./Youtube";
export { default as Search } from "./Search";
export { default as ArrowUp } from "./ArrowUp";
export { default as ArrowDown } from "./ArrowDown";
export { default as Telegram } from "./Telegram";
